import { useAccountsSectionController } from "./accounts/useAccountsSectionController";
import { useUsersSectionController } from "./users/useUsersSectionController";
import { useQuickbooksSectionController } from "./quickbooks/useQuickbooksSectionController";
import { useReportsSectionController } from "./reports/useReportsSectionController";

function UsersSectionProvider(props) {
  const contract = useUsersSectionController(props);
  return props.children(contract);
}

function AccountsSectionProvider(props) {
  const contract = useAccountsSectionController(props);
  return props.children(contract);
}

function QuickbooksSectionProvider(props) {
  const contract = useQuickbooksSectionController(props);
  return props.children(contract);
}

function ReportsSectionProvider(props) {
  const contract = useReportsSectionController(props);
  return props.children(contract);
}

export const managementSectionRegistry = {
  users: {
    id: "users",
    order: 1,
    Provider: UsersSectionProvider,
  },
  accounts: {
    id: "accounts",
    order: 2,
    Provider: AccountsSectionProvider,
  },
  quickbooks: {
    id: "quickbooks",
    order: 3,
    Provider: QuickbooksSectionProvider,
  },
  reports: {
    id: "reports",
    order: 4,
    Provider: ReportsSectionProvider,
  }
};

export function getSectionProvider(sectionId) {
  return managementSectionRegistry[sectionId]?.Provider || null;
}
